import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import '../TaskListLayout/TaskLayout.css';
import PropTypes from 'prop-types';
import { getDateFormat } from '../../utils/utils';
import { displayToast } from '../../_helpers/commonFunctions';
import DeficiencyIcon from '../../components/DeficiencyIcon';
import { hasDeficiency, getDeficiencyForIcon } from '../../utils/deficiencyHelpers';

/**
 * Complete Report Layout Row component
 */
const CompleteReportLayoutRow = (props) => {
  const {
    row,
    setSelectedReportEditId,
    setClassVisibility,
    isClassVisible,
    country,
  } = props;
  const idToExpand = Object.keys(isClassVisible);
  const isIdToExpand = isClassVisible[idToExpand[0]];

  /**
   * Check if report has a linked deficiency and is Quote or Work Order type
   */
  const shouldShowDeficiencyIcon =
    hasDeficiency(row.deficiencyId) &&
    (row.reportType === 'Quote' || row.reportType === 'Work Order');
  
  /**
   * Get deficiency object for the icon
   */
  const deficiencyForIcon = getDeficiencyForIcon(row.deficiencyId);

  /**
   * Handle deficiency icon click
   */
  const handleDeficiencyClick = (deficiency) => {
    try {
      // Validate deficiency before passing to parent
      if (!deficiency || !deficiency._id) {
        console.error('[CompleteReportLayoutRow] Invalid deficiency clicked:', deficiency);
        displayToast('Unable to view deficiency details.', 'error');
        return;
      }
      
      // Pass the deficiency up to parent to handle modal
      if (props.onDeficiencyClick) {
        props.onDeficiencyClick(deficiency);
      }
    } catch (err) {
      console.error('[CompleteReportLayoutRow] Error handling deficiency click:', err);
      displayToast('An error occurred. Please try again.', 'error');
    }
  };

  return (
    <tr
      className={
        row._id === idToExpand[0] && isIdToExpand
          ? 'accordion-opened test-class'
          : 'test-class'
      }
      style={
        row._id === idToExpand[0] && isIdToExpand
          ? { maxHeight: '1000px', cursor: 'pointer' }
          : { maxHeight: '60px', cursor: 'pointer' }
      }
      onClick={() => setSelectedReportEditId(row)}
    >
      <td id="">
        <h3>
          <FormattedMessage id="Customer Name" defaultMessage="Customer Name" />
        </h3>
        {row.createdForName}
      </td>

      <td id="">
        <h3>
          <FormattedMessage id="Category" defaultMessage="Category" />
        </h3>
        {row.reportCategory}
      </td>

      <td id="">
        <h3>
          <FormattedMessage id="Start Date" defaultMessage="Start Date" />
        </h3>
        {moment(row.createdAt).format(
          getDateFormat()
        )}
      </td>
      <td id="">
        <h3>
          <FormattedMessage id="Modified Date" defaultMessage="Modified Date" />
        </h3>
        {moment(row.updatedAt).format(
          getDateFormat()
        )}
      </td>
      <td id="">
        <h3>
          <FormattedMessage id="Actions" defaultMessage="Actions" />
        </h3>
        {shouldShowDeficiencyIcon && deficiencyForIcon && (
          <DeficiencyIcon
            deficiency={deficiencyForIcon}
            onClick={handleDeficiencyClick}
            tooltipText={
              deficiencyForIcon.status 
                ? `Status: ${deficiencyForIcon.status}` 
                : 'View deficiency details'
            }
          />
        )}
      </td>
      <span
        className="icon-accordion"
        onClick={() => setClassVisibility(row._id)}
      >
        {row._id === idToExpand[0] && isIdToExpand ? '-' : '+'}
      </span>
    </tr>
  );
};
CompleteReportLayoutRow.propTypes = {
  row: PropTypes.object,
  index: PropTypes.number,
  reportHeading: PropTypes.string,
  setSelectedReportInfoId: PropTypes.func,
  setSelectedReportEditId: PropTypes.func,
  isClassVisible: PropTypes.object,
  setClassVisibility: PropTypes.func,
  country: PropTypes.string,
  onDeficiencyClick: PropTypes.func,
};

const mapStateToProps = ({ auth }) => ({
  country: auth.login.user.businessAddress.country.toLowerCase(),
});
export default connect(mapStateToProps)(CompleteReportLayoutRow);
